<template>
  <el-dialog title="派发门票" :visible.sync="dialogFormVisible" width="900px">
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:name>
        <el-table-column label="姓名" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:mobile>
        <el-table-column label="手机号" width="150" align="center">
          <template slot-scope="scope"> {{ scope.row.contact.mobile }}</template>
        </el-table-column>
      </template>
    </Table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveData">确认派发</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { assignTicket } from '@/api/orders'

export default {
  name: 'AssignTicket',
  data() {
    return {
      list: null,
      listLoading: true,
      columns: [
        {
          label: '姓名',
          slot: 'name'
        },
        {
          label: '手机号',
          slot: 'mobile'
        },

        {
          label: '门票数量',
          width: '80',
          prop: 'user_num',
          align: 'center'
        },
        {
          label: '景区',
          prop: 'product_name',
          width: '200',
          align: 'center',
          showOverflowTooltip: true
        },
        {
          label: '出行日期',
          minWidth: '120',
          prop: 'use_date',
          align: 'center'
        }
      ],
      dialogFormVisible: false,
      sn: ''
    }
  },
  methods: {
    /**
     * @description: 详情
     * @param {*} row
     * @return {*}
     */
    handleAssignTicket(row) {
      this.list = [row]
      this.dialogFormVisible = true
      this.listLoading = false
    },
    /**
     * @description: 核单
     * @return {*}
     */
    saveData() {
      assignTicket(this.list[0].sn).then(() => {
        this.$parent.fetchData()
        this.dialogFormVisible = false
        this.$parent.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success'
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.sn {
  margin-bottom: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: right;
  .el-button {
    width: 120px;
    letter-spacing: 2px;
    font-weight: 600;
  }
}
</style>
